
define('eteration/ui/signup-viewmodel',['jquery',
        'knockout',
        'underscore',
        'eteration/ui/form-viewmodel',
        'eteration/eteration-ajax',
        'eteration/widgets/ui-i18n',
        'eteration/eteration-base',
        'eteration/eteration-i18n',
		'common/recaptcha-constants',
        'eteration/ui/validation-helper',
        'eteration/widgets/ui-combodate',
        'eteration/widgets/ui-etrselect',
        'eteration/widgets/ui-recaptcha',
        'eteration/widgets/ui-form-items',
        'eteration/ui/ko-validation',
        'eteration/widgets/ui-etrselect',
        'eteration/widgets/ui-dropdownselect',
        'eteration/widgets/ui-selectpicker',
        'eteration/widgets/ui-cms'
        ], 
	function($, ko,underscore,BaseViewModel, etrAjax,ui18,Eteration,i18n, recaptchaConstants,validation) {

	
				function SecurityInfo(){
					var self = this;
				    self.password=ko.observable();
				    self.repassword=ko.observable();
				    self.squestion=ko.observable();
				    self.securityQuestionCode=ko.observable();
				    self.sanswer=ko.observable();
					self.recaptchaDomain = ko.observable(recaptchaConstants.domain());

				    self.json = function(){
				    	return { password: self.password()};
				    };
			
				};
				
				function PersonalInfo(){
					var self = this;

				    self.acdTitle = ko.observable();
				    self.nationality = ko.observable();
				    self.firstName = ko.observable();
				    self.secondName = ko.observable();
				    self.surname = ko.observable();
				    self.birthDate = ko.observable();
				    self.email = ko.observable();

				    self.prfLanguage = ko.observable();
				    self.gender = ko.observable("F");
				    self.tcId = ko.observable();
				};
				
				function AddressInfo(){
					var self = this;
				    self.addressType = ko.observable();
				    self.addressTypeCode = ko.observable("H");
				    self.addressLine1 = ko.observable();
				    self.addressLine2 = ko.observable();
				    self.townCode = ko.observable();
				    self.cityCode = ko.observable();
				    self.postCode = ko.observable();
				    self.countryCode = ko.observable();
				    self.stateCode = ko.observable();
				    self.hasState = ko.observable('');
				    self.phoneType = ko.observable();
				    self.homePhoneNumber = ko.observable();	
				    self.homePhoneCountryCode = ko.observable();
				    self.mobilePhoneNumber = ko.observable();	
				    self.mobilePhoneCountryCode = ko.observable();
				};
				

				
				function RecaptchaInfo(){
					var self = this;
					self.publicKey = ko.observable();
				    self.privateKey = ko.observable();
				    self.remoteIp = ko.observable();
				    self.challenge = ko.observable();
				    self.response = ko.observable();
				};
				
				
				function MilesProgramInfo(){
					var self = this;

					self.plasticCardNumber = ko.observable();
				};
				
				
				
	
				function MilesAndSmilesSingUpVM(refresh, passenger) {
					var self = this;
					ko.utils.extend(self, new BaseViewModel.FormViewModel());
				    
					//personal info
					self.personalInfo = ko.observable(new PersonalInfo());
				    //security info
				    self.securityInfo = ko.observable(new SecurityInfo());
				    //address info
					self.addressInfo = ko.observable(new AddressInfo());
				    //general info
//					self.generalInfo = ko.observable(new GeneralInfo());
					//general info
					self.milesProgramInfo = ko.observable(new MilesProgramInfo());
					//recaptcha info
					self.recaptchaInfo = ko.observable(new RecaptchaInfo());	
				    //iletisim tercihi
				    self.selectedContactList=ko.observableArray();
				    self.shareMembersData = ko.observable(false);
				    self.agreement=ko.observable();
				    self.agreementInfo=ko.observable();

				    
				//page lists    
				    
				   self.academicTitles=ko.observableArray();
				   self.countries=ko.observableArray();
				   self.nationalities=ko.observableArray();				   
				   self.adrcities=ko.observableArray();
				   self.adrstates=ko.observableArray();
				   self.languages=ko.observableArray();
				   self.meals=ko.observableArray();
				   self.industries=ko.observableArray();
				   self.cities=ko.observableArray();
				   self.districts = ko.observableArray();
				   self.addressTypes=ko.observableArray();
				   self.hobbies=ko.observableArray();	
				   self.jobtitles=ko.observableArray();
				   self.musics=ko.observableArray();	
				   self.questions=ko.observableArray();
				   self.seats=ko.observableArray();
				   self.airlinePrograms=ko.observableArray();
				   self.contactPreferences=ko.observableArray();
				   self.genders = ko.observableArray();
		
				   self.isTurkishCitizen = ko.observable(false);
				   self.regionCodes = ko.observableArray();
				   
				   self.userCountry = ko.observable(i18n.getUserCountry());
				   self.userLanguage = ko.observable(i18n.getUserLocale());
				   
				   
				   self.passenger = ko.observable(passenger);
				   if(self.passenger() && self.passenger().personalInfo) {
					   self.personalInfo().firstName(self.passenger().personalInfo.name);
					   self.personalInfo().surname(self.passenger().personalInfo.surname);
				   }
				 
				   self.updateHomePhoneMaxLength = function(){
					   self.addressInfo().homePhoneNumber("");
					   var phoneNumberMaxLength = 15 - self.addressInfo().homePhoneCountryCode().length;
					   $("#signup-homePhoneNumber").attr("maxlength", phoneNumberMaxLength);
					};
				   self.updateMobilePhoneMaxLength = function(){
					   self.addressInfo().mobilePhoneNumber("");
					   var phoneNumberMaxLength = 15 - self.addressInfo().mobilePhoneCountryCode().length;
					   $("#signup-mobilePhoneNumber").attr("maxlength", phoneNumberMaxLength);
					};
				   
					
					
				   self.validationContext = ko.jqValidation({
		                customValidators : {
		                	passwordMatchValidator : function(el) {
		                			if(self.securityInfo().repassword()!=self.securityInfo().password())
		                				return i18n.get("ERR-MS-LOGIN-25");

		                	},
		                	
	    				
		    				mobilCountryCodeValidator : function(el) {
		    					if(!self.addressInfo().mobilePhoneCountryCode()){
		    						return i18n.get("ERR-MS-LOGIN-380");
		    					}      		
		    				},
		    				
		    				townCodeValidator : function(el) {
		    					if(self.addressInfo().countryCode() == "TR" &&  (self.addressInfo().townCode()==null || self.addressInfo().townCode()=="" )){
		    						return i18n.get("ERR-MS-LOGIN-380");
		    					}      		
		    				}
		                },
		                postValidators:[	
            					  {
	            						name:"signup-repassword",
	            						id:"signup-repassword",
	            						func:function() {
	        							if(self.securityInfo().repassword()!=self.securityInfo().password())
	        								return i18n.get("ERR-MS-LOGIN-25");
	            						}
            					  },
            					  {
	            						name:"signup-agreement",
	            						id:"signup-agreement",
	            						func:function() {
	        							if(!self.agreement())
	        								return i18n.get("ERR-MS-LOGIN-38");
	            						}
          						
            					  },
            					  {
	            						name:"signup-agreementInfo",
	            						id:"signup-agreementInfo",
	            						func:function() {
	        							if(!self.agreementInfo())
	        								return i18n.get("ERR-MS-LOGIN-62");
	            						}
        						
          							},
            					    {
	            						name:"errorcaptchaDivIdForMilesSignUp",
	            						id:"errorcaptchaDivIdForMilesSignUp",
	            						func:function() {
	            							if(grecaptcha.getResponse().length === 0){
	            								return i18n.get("ERR-MS-LOGIN-380");
	            							}
	            						}
        						
          					  }
		              ]
 	
		            });
				   
				   self.responseMessageCodes = ko.observableArray();
				   
				   self.registerUser = function(){
					   
					    var validationResult = self.validationContext.Validate();
					    
					    if (validationResult.valid && self.isValidBirthDate()) {
					    	self.recaptchaInfo().response($("#g-recaptcha-response").val());
		                    etrAjax.post({
					    		app: 'app.ms',
					    		service:'/miles/signup',
					    		data :{personalInfo : JSON.parse(ko.toJSON(self.personalInfo())),
					    			   securityInfo : JSON.parse(ko.toJSON(self.securityInfo())),
					    			   addressInfo  : JSON.parse(ko.toJSON(self.addressInfo())),
//					    			   generalInfo  : JSON.parse(ko.toJSON(self.generalInfo())),
					    			   milesProgramInfo  : JSON.parse(ko.toJSON(self.milesProgramInfo())),
					    			   recaptchaInfo  : JSON.parse(ko.toJSON(self.recaptchaInfo())),
					    			   selectedContactList : self.selectedContactList(),
					    			   shareMembersData : self.shareMembersData(),
					    			   agreement : self.agreement()},
					    		callback:function(response) {
					    			// LOGIN AFTER SIGN UP
					    			
						  			 if(response.data.successfullySignedUp){   
						  				var milesProgramInfo = response.data.milesProgramInfo;
						  				var loginId = response.data.milesProgramInfo.ffId.substring(2);			
						    			
						    			etrAjax.post({
								    		app: 'app.ms',
								    		disableLoader : true,
								    		service:'/login/signin',
											setTokenX: true,
								    		data : {
								    				'username' : loginId,
								    				'loginType': '1',
								    				'password' : response.data.securityInfo.password,
								    				'recaptchaInfo'  : JSON.parse(ko.toJSON(self.recaptchaInfo()))
								    		},
								    		callback:function(response) {
								    			
								    			if(passenger) {
									        		var cardNumber = milesProgramInfo.ffId.substring(2);
									        		var cardTypeCode = milesProgramInfo.ffId.substring(0,2);
									        		
									        		var passengerFQTVInfo = {rph:passenger.rph,fqtvInfo:{cardNumber: cardNumber, ffpProgram: cardTypeCode}};
									        		var passengerFQTVInfoList = [passengerFQTVInfo];
													var savePassengerFQTVInfo ={
											    		app: 'app.ibs',
											    		service:'/booking/fqtvinfo',
											    		data:passengerFQTVInfoList,
											    		callback:function(response) {
											    		}
													};
													etrAjax.post(savePassengerFQTVInfo);
									        	}
								    			
								        		$('#signupModal').modal('toggle');
									        	window.location.reload();
								    		}
									    });	
						    			
						    		} else {
						    			// hides signup modal when there is error codes
						    			$('#signupModal').modal('hide');
						    			
						    			self.responseMessageCodes(response.data.responseMessageCodes);
						    			
						    			$('#signupInfoMessage').modal('show');
						    			
						    		}
						  			
					    			
					    			
					    		},
					    		uiMap:uiMap
						    });
		                    
		                } else {
							 grecaptcha.reset();
						}
					  
					    
				    };
				    
				    self.showHiddenSignupForm = function(){
				    	$('#signupInfoMessage').modal('hide');
				    	setTimeout(function(){
				    		$('#signupModal').modal('show');
				    	},500);
				    }
				    
				    self.isValidBirthDate=function(){	
				    	if(self.personalInfo().birthDate() != undefined && self.personalInfo().birthDate() != ""){
					    	var currentDate = new Date();
					    	var parts = self.personalInfo().birthDate().split("-");
					    	var birthDate = new Date(parts[1]+"-"+parts[0]+"-"+parts[2]);
					    	$("#invalidBirthDate").css("display", "none");
					    	if(currentDate.getFullYear()- birthDate.getFullYear()==2){
						    	if(currentDate.getMonth()+1 < birthDate.getMonth()+1){
						    		$("#invalidBirthDate").css("display", "block");
						    		return false;
						    	}
						    	else if(currentDate.getMonth()+1 == birthDate.getMonth()+1){
						    		if(currentDate.getDate() < birthDate.getDate()){
						    			$("#invalidBirthDate").css("display", "block");
						    			return false;
						    		}
						    	}
					    	}
				    	}
				    	return true;
					};
				    
					
					var  gendersQuery ={
							app: 'app.ms',
							service:'/parameters/genders',
							callback:function(response) {
								self.genders(response.data);
							}
					};
				   
				   var  academicTitlesQuery ={
			    		app: 'app.ms',
			    		service:'/parameters/academictitles',
			    		callback:function(response) {
			    			self.academicTitles(response.data);
			    		}
				   };
				   
				   var  countriesQuery ={
				    		app: 'app.ms',
				    		service:'/parameters/countries',
				    		callback:function(response) {
				    			self.countries(response.data);
				    		}
					};
				   
				   var  nationalitiesQuery ={
				    		app: 'app.ms',
				    		service:'/parameters/nationalities',
				    		callback:function(response) {
				    			self.nationalities(response.data);
				    		}
					};
				  
				  var  languagesQuery ={
				    		app: 'app.ms',
				    		service:'/parameters/languages',
				    		data :{"" : self.addressInfo().countryCode()},
				    		callback:function(response) {
				    			self.languages(response.data);
				    		}
					};

				   var  questionsQuery ={
				    		app: 'app.ms',
				    		service:'/parameters/securityquestions',
				    		callback:function(response) {
				    			self.questions(response.data);
				    		}
					};

									   
					var  adressTypesQuery ={
					   		app: 'app.ms',
					    	service:'/parameters/adresstypes',
					    	callback:function(response) {
					    		self.addressTypes(response.data);
					    	}
					};	

					   
				   var  regionCodesQuery ={
				    		app: 'app.ms',
				    		service:'/parameters/regioncodes',
							disableLoader: true,
				    		callback:function(response) {
				    			self.regionCodes(response.data);
				    			var homeCodeLength = $("#signup-homePhoneNumberCode").val() ? $("#signup-homePhoneNumberCode").val().length : 0;
				    			var mobileCodeLength = $("#signup-mobilePhoneNumberCode").val() ? $("#signup-mobilePhoneNumberCode").val().length : 0;
				    			
								var defaultHomePhoneNumberMaxLength = 15 - homeCodeLength;
								$("#signup-homePhoneNumber").attr("maxlength", defaultHomePhoneNumberMaxLength);
								   
								var defaultMobilePhoneNumberMaxLength = 15 - mobileCodeLength;
								$("#signup-mobilePhoneNumber").attr("maxlength", defaultMobilePhoneNumberMaxLength);
				    		}
				   
					};
				   

				   var  passwordLengthFromAdminQuery ={
						   app: 'app.ms',
						   service:'/miles/passwordlengthfromadmin',
						   callback:function(response) {
							   
							   $("#signup-password").attr("maxlength", response.data);
							   $("#signup-repassword").attr("maxlength", response.data);
						   }
				   
				   };

				   var  securityQuestionAnswerFromAdminQuery ={
						   app: 'app.ms',
						   service:'/miles/securityquestionanswerfromadmin',
						   disableLoader: true,
						   callback:function(response) {
							   $("#signup-sanswer").attr("maxlength", response.data.maxLength);
						   }
				   
				   };
						
				   etrAjax.multiGet([gendersQuery, academicTitlesQuery,countriesQuery,nationalitiesQuery,languagesQuery,adressTypesQuery,regionCodesQuery, questionsQuery,passwordLengthFromAdminQuery,securityQuestionAnswerFromAdminQuery]);
					
				    
				   self.nationalityChange=function(){
					   if(self.personalInfo().nationality()=="TR"){
						   self.isTurkishCitizen(true);

					   }else{
						   self.isTurkishCitizen(false);
						   self.shareMembersData(false);
					   }
				   };
				   
					 

				   self.countryChange=function(){
					   var countryData = underscore.find(self.countries(), function(property) { return property.code === self.addressInfo().countryCode() });
					   
					   if(countryData != undefined && countryData.data != null && countryData.data.hasState == "1"){
						   self.addressInfo().hasState(countryData.data.hasState);
						   
						   etrAjax.get({
					    		app: 'app.ms',
					    		service:'/parameters/addressStates',
					    		data :{"countryCode" : self.addressInfo().countryCode()},
					    		callback:function(response) {
					    			self.adrstates.removeAll();
					    			self.adrstates(response.data.sort(function(a,b) { return a.name < b.name ? -1 : a.name > b.name ? 1 : 0; }));
					       		}
							});
					   }else{
						   self.addressInfo().hasState(undefined);
						   self.addressInfo().stateCode(null);
						   etrAjax.get({
					    		app: 'app.ms',
					    		service:'/parameters/addressCities',
					    		data :{"countryCode" : self.addressInfo().countryCode(),
					    			   "stateCode" : self.addressInfo().stateCode() ? self.addressInfo().stateCode() : null},
					    		callback:function(response) {
					    			self.adrcities.removeAll();
					    			self.adrcities(response.data);
					    		}
						});
					   }
				   
						   
				   };
				   
				   
				   
				   self.districtForState = function(){
					   
					   etrAjax.get({
				    		app: 'app.ms',
				    		service:'/parameters/addressCities',
				    		data :{"countryCode" : self.addressInfo().countryCode(),
				    			   "stateCode" : self.addressInfo().stateCode()},
				    		callback:function(response) {
				    			self.adrcities.removeAll();
				    			self.adrcities(response.data);
				    		}
					});
				   
					  
				   }
				   
				   self.districtForCity = function(){
					   etrAjax.get({
						   app: 'app.ms',
						   service:'/parameters/districts/'+self.addressInfo().cityCode(),
						   callback:function(response) {
							   self.districts.removeAll();
							   self.districts(response.data);
						   }
					   })
				   }
				    
					
					self.showPasswordRules = function(){
						$("#passwordRuleModal").modal("toggle");
					}
					
					self.selectpicker =function(){
						$('.dropdownselect').selectpicker();
					};
					
					self.selectpickerRefresh =function(){
						$('.dropdownselect').selectpicker('refresh');
					};
				    		
					self.clearPassengerSelections = function() {
						$('#signupBTN').removeData("passenger");
						$('body').removeClass('modal-open');
						$('.modal-backdrop').remove();
					};
					
					   
				   var uiMap = {
						'personalInfo.acdTitle':'title' ,
						'personalInfo.nationality':'nationality' ,
						'personalInfo.firstName':'firstname' ,
						'personalInfo.surname':'surname' ,
						'personalInfo.birthDate':'birthDate' ,						
						'personalInfo.email':'email',
						'personalInfo.gender' : 'gender',
						'personalInfo.prfLanguage' : 'prfLanguage',
						'addressInfo.addressType':'addressType',
						'addressInfo.addressLine1':'addressLine1',
						'addressInfo.addressLine2':'addressLine2',
						'addressInfo.countryCode':'countryCode',
						'addressInfo.cityCode':'cityCode',
						'addressInfo.town':'town',
						'addressInfo.postCode':'postCode',
						'addressInfo.phoneType':'phoneType',
						'addressInfo.homePhoneCountryCode':'homePhoneCountryCode',
						'addressInfo.homePhoneNumber':'homePhoneNumber',
						'addressInfo.mobilePhoneCountryCode':'mobilePhoneCountryCode',
						'addressInfo.mobilePhoneNumber':'mobilePhoneNumber',
						'securityInfo.password':'signup-password',
						'securityInfo.repassword':'signup-password',
						'securityInfo.squestion':'squestion',
						'securityInfo.sanswer':'sanswer',	
						'recaptchaInfo.errorcaptchaDivId' : 'errorcaptchaDivId'	
						
				   };
					
				    
				};

				return { ViewModel:  MilesAndSmilesSingUpVM };

});
	